import { render } from "./designations.vue?vue&type=template&id=c77f3056"
import script from "./designations.vue?vue&type=script&lang=js"
export * from "./designations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__